import TagManager from 'react-gtm-module';

import { isProdOrStaging } from '../env';

import { useCountryFromLocale } from './useCountryFromLocale';

import type { DataLayerArgs } from 'react-gtm-module';

export enum GTMEvent {
  HOME = 'home',
  FILE_CLAIM = 'file-claim',
  INVOICES = 'invoices',
  SUPPORT = 'support',
  LOGOUT = 'logout',
  LET_US_KNOW = 'let-us-know',
  POLICY_DOWNLOAD = 'policy-download',
  MY_POLICIES = 'my-policies',
  MY_SAFETY_NET = 'my-safety-net',
  COI = 'certificate-of-insurance',
}

export function useTagManager(): {
  dataLayerPush: (args: DataLayerArgs) => void;
  sendEvent: (event: GTMEvent, payload?: Record<string, string>) => void;
} {
  const country = useCountryFromLocale();

  function dataLayerPush(args: DataLayerArgs) {
    if (!isProdOrStaging) return;

    TagManager.dataLayer(args);
  }

  function sendEvent(event: GTMEvent, payload?: Record<string, string>) {
    const args: DataLayerArgs = {
      dataLayer: {
        event,
        country,
        ...payload,
      },
    };
    dataLayerPush(args);
  }

  return { dataLayerPush, sendEvent };
}
